import { useFlag } from '@/feature/feature-flags'

export const useAreGeoFencesEnabled = (): boolean =>
  useFlag('featureGeofences', false) !== false
